module.exports = __webpack_public_path__ + "img/keepcovered-logo.7870655b.jpg";